import { Routes } from '@angular/router';
import {
  ApplicantDataComponentConfig,
  ApplicantDataSectionComponent
} from '../common/applicant-data-section/applicant-data-section.component';
import {
  ApplicationDataComponentConfig,
  ApplicationDataSectionComponent
} from '../common/application-data-section/application-data-section.component';
import {
  LocalisationDataComponentConfig
} from '../common/localisation-data-section/localisation-data-section.component';
import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from '../common/agreements-data-section/agreements-data-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import {
  ContractorDataComponentConfig,
  ContractorDataSectionComponent
} from '../common/contractor-data-section/contractor-data-section.component';
import {
  ConsentLocationOfBuildingsSmallerDistanceLocalisationDataSectionComponent
} from './sections/consent-location-of-buildings-smaller-distance-localisation-data-section/consent-location-of-buildings-smaller-distance-localisation-data-section.component';

export const stages: string[] = [
  'Wnioskodawca',
  'Dane wniosku',
  'Inwestor',
  'Lokalizacja',
  'Zgody',
  'Załączniki'
];

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages
};

export const applicationDataSectionConfig: ApplicationDataComponentConfig = {
  stages,
  successUrl: '../inwestor',
  cancelUrl: '../wnioskodawca',
  addApplicationSubjectControl: true,
  applicationSubjectControlType: 'select',
  applicationSubjectOptions: [
    'Lokalizacji obiektu budowlanego',
    'Lokalizacji reklamy',
    'Lokalizacja reklamy posadowionej na obiekcie budowlanym'
  ]
};

export const contractorDataSectionConfig: ContractorDataComponentConfig = {
  stages,
  cancelUrl: '../dane-wniosku',
  successUrl: '../lokalizacja',
  customTitles: {
    sectionTitle: 'Inwestor',
    dataSameAsApplicantLabels: {
      rejectLabel: 'Chcę wprowadzić dane inwestora',
      acceptLabel: 'Dane inwestora są takie same jak dane wnioskodawcy'
    },
    cardTitle: 'Dodanie inwestora',
    addBtnTitle: 'Dodaj inwestora',
    addBtn2Title: 'Dodaj kolejnego inwestora',
    noDataInfo: 'Brak dodanych inwestorów!'
  }
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../lokalizacja',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const consentLocationOfBuildingsSmallerDistanceRoutes: Routes = [
  {
    component: ApplicantDataSectionComponent,
    path: 'wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicantDataSectionComponent,
    path: ':appId/wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicationDataSectionComponent,
    path: ':appId/dane-wniosku',
    data: applicationDataSectionConfig
  },
  {
    component: ContractorDataSectionComponent,
    path: ':appId/inwestor',
    data: contractorDataSectionConfig
  },
  {
    component: ConsentLocationOfBuildingsSmallerDistanceLocalisationDataSectionComponent,
    path: ':appId/lokalizacja'
  },
  {
    component: AgreementsDataSectionComponent,
    path: ':appId/zgody',
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  { path: '', redirectTo: 'wnioskodawca', pathMatch: 'prefix' }
];
